// extracted by mini-css-extract-plugin
module.exports = {"sized":"icon_sized__dN4sf","textAligned":"icon_textAligned___cc8F"};